import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {PoolPO} from "@/model/customer";
import {WritePoolForm} from "@/pages/Pool/WritePool";

export enum PoolEnum {
    GetPoolPage = "/pool/getPoolPage",
    GetPool = "/pool/getPool",
    CreatePool = "/pool/createPool",
    UpdatePool = "/pool/updatePool",
    ReceivePool = "/pool/receivePool",
}

export interface PoolPageBO {
    keyword?: string;
}

export interface ReceivePoolBO {
    poolIds: number[];
}

export const useQueryPoolPage = () => useMutation({
    mutationFn: (data: PoolPageBO) => http.post<BaseVO<PaginationVO<PoolPO>>>({
        url: PoolEnum.GetPoolPage,
        data: data,
    }),
})

export const useCreatePool = () => useMutation({
    mutationFn: (data: WritePoolForm) => http.put({url: PoolEnum.CreatePool, data}),
})

export const useReceivePool = () => useMutation({
    mutationFn: (data: ReceivePoolBO) => http.post<BaseVO<null>>({url: PoolEnum.ReceivePool, data}),
})

export const useUpdatePool = () => useMutation({
    mutationFn: (data: WritePoolForm) => http.post({url: PoolEnum.UpdatePool, data}),
})

export const useQueryPool = (params: GetByIdBO, enabled?: boolean) => useQuery<BaseVO<PoolPO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<PoolPO>>({
        url: PoolEnum.GetPool,
        params: params
    }),
    enabled: enabled,
})

